// src/pages/Enseignants/ListingAdherents/components/AdherentsGrid.jsx
import React, { useMemo, useState } from "react";
import AdherentCard from "./AdherentCard";
import Button from "./../../../components/Button/Button";
import { FaEye } from "react-icons/fa";

const AdherentsGrid = ({
  adherents,
  birthdaySet,
  getDefaultPhoto,
  onSelect,
  isAdmin,
  onEdit,
  onChangeGroup,
  onManageGroups,
  pageSize = 24,
  refreshData
}) => {
  const [page, setPage] = useState(1);
  const max = Math.max(1, Math.ceil((adherents?.length || 0) / pageSize));

  const pageData = useMemo(() => {
    const end = page * pageSize;
    return (adherents || []).slice(0, end);
  }, [adherents, page, pageSize]);

  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {pageData.map((a) => (
          <AdherentCard
            key={a.id}
            adherent={a}
            isBirthday={birthdaySet.has(a.id)}
            getDefaultPhoto={getDefaultPhoto}
            onClick={onSelect}
            isAdmin={isAdmin}
            onEdit={onEdit}
            onChangeGroup={onChangeGroup}
            onManageGroups={onManageGroups}
            refreshData={refreshData}
          />
        ))}
      </div>

      {page < max && (
        <div className="flex justify-center mt-6">
          <Button
            text="Afficher plus"
            icon={FaEye}
            onClick={() => setPage((p) => p + 1)}
            className="!rounded-xl !shadow-md gap-2"
          />
        </div>
      )}
    </>
  );
};

export default AdherentsGrid;
